<h2 mat-dialog-title>{{ title }}</h2>
<mat-dialog-content style="min-width: 50vw;">
  <form [formGroup]="form">
    <ng-container *ngFor="let field of fields">
        <ng-container [ngSwitch]="field.value.type">

          <mat-form-field *ngSwitchCase="'text'" appearance="outline" class="full-width">
            <mat-label>{{ (field.value.label | translate) || 'Text' }}</mat-label>
            <input matInput [formControlName]="field.key" />
          </mat-form-field>

          <mat-form-field *ngSwitchCase="'email'" appearance="outline" class="full-width">
            <mat-label>{{ (field.value.label| translate) || 'Email' }}</mat-label>
            <input matInput type="email" [formControlName]="field.key" />
          </mat-form-field>

          <mat-form-field *ngSwitchCase="'number'" appearance="outline" class="full-width">
            <mat-label>{{ (field.value.label | translate)  }}</mat-label>
            <input matInput type="number" [formControlName]="field.key" />
          </mat-form-field>

          <mat-form-field *ngSwitchCase="'select'" appearance="outline" class="full-width">
            <mat-label>{{ (field.value.label | translate)  }}</mat-label>
            <mat-select [formControlName]="field.key"  (click)="onSelectOpened($event, field)">
              <mat-option *ngFor="let option of field.value.options" [value]="option.value">
                <mat-icon
                  *ngIf="option?.icon"
                  [svgIcon]="option?.icon"
                  class="text-current"></mat-icon>
                {{ option.label | translate }}
              </mat-option>
            </mat-select>
          </mat-form-field>

        </ng-container>

      <ng-container [ngSwitch]="field.value.type">
        <app-avatar-upload [formControlName]="field.key" [form]="form" *ngSwitchCase="'image'"></app-avatar-upload>
        <vex-rich-text-editor *ngSwitchCase="'textarea'" [formControlName]="field.key" [(content)]="content"></vex-rich-text-editor>
      </ng-container>
<!--        <mat-error *ngIf="form.controls[field.key].invalid && form.controls[field.key].touched">-->
<!--          {{ field.value.label | translate  }} is required-->
<!--        </mat-error>-->

    </ng-container>

  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-flat-button color="primary" (click)="onSave()" [disabled]="form.invalid">
    {{ data.action === 'add' ? ('Create' | translate) : ('Save' | translate) }}
  </button>
</mat-dialog-actions>
